module.exports = __webpack_public_path__ + "static/media/33_bsp.cb6d2179.mp3";